"use strict";require('@ebay/skin/link');